// extracted by mini-css-extract-plugin
export default {"wrap":"Card_wrap__UWIUb","card":"Card_card__sbVfS","icon":"Card_icon__fktsb","title":"Card_title__pTHbg","value":"Card_value__x3eOS"};